export default __webpack_public_path__ + "static/media/bspring25.5c25f1dd.webp";